import { render } from "./ArgonInput.vue?vue&type=template&id=5c5be18a"
import script from "./ArgonInput.vue?vue&type=script&lang=js"
export * from "./ArgonInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__